import React, { useEffect } from 'react';
import IvoriMethodDegreeApprenticeshipPage from '../../features/method/IvoriMethodDegreeApprenticeshipPage';

export default function IvoriMethodDegreeApprenticeshipRoute() {
  useEffect(() => {
    document.title = "The IVORI Method — Degree Apprenticeship Assessment-Centre Pedagogy | Pathbuddy";
    window.scrollTo(0, 0);
  }, []);

  return <IvoriMethodDegreeApprenticeshipPage />;
}
